import React from "react";
import { Link } from "react-router-dom";

export const NoMatch = ({ location }) => (
    <div style={{ textAlign: "center", paddingTop: "100px" }}>
        <h2>
            No match for <code>{location.pathname}</code>
        </h2>
        <p style={{ fontSize: "62px", margin: "40px 0", fontWeight: "bold" }}>
            PAGE 404
        </p>
        <p>
            <Link to={"/"}>Home</Link>
        </p>
    </div>
);
